var r = Object.defineProperty;
var c = (t, e, s) => e in t ? r(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var n = (t, e, s) => (c(t, typeof e != "symbol" ? e + "" : e, s), s);
function u(t) {
  return {
    message: "platformInit",
    pageHasExtensionInstallIframe: t
  };
}
function d(t) {
  const e = t.session.configurations.exam_toggles;
  return {
    alerts: t.session.alerts ?? [],
    message: "sessionSetup",
    app_url: t.app_url,
    student: t.session.session,
    exam_toggles: h(e),
    translations: t.session.configurations.translations,
    shortcut_detection_enabled: t.session.configurations.shortcut_detection_enabled,
    simulated: t.session.configurations.simulated,
    guidelines: {
      allowed_messages: t.session.configurations.guidelines.allowed_messages,
      not_allowed_messages: t.session.configurations.guidelines.not_allowed_messages
    },
    whitelisted_urls: t.session.configurations.whitelisted_urls,
    additional_instructions: t.session.configurations.additional_instructions,
    camera_url: t.session.camera_url,
    external_exam_id: t.external_exam_id,
    exam_taker_id: t.exam_taker_id,
    exam_taker_name: t.exam_taker_name,
    exam_taker_attempt_id: t.exam_taker_attempt_id,
    additionally_supported_url: t.additionally_supported_url
  };
}
function h(t) {
  const e = {};
  return t.forEach((s) => {
    e[s.id] = s;
  }), e;
}
function m(t, e) {
  return {
    message: "launchCamera",
    session_id: t,
    camera_url: e
  };
}
function g(t, e, s) {
  return {
    message: "questionLoaded",
    question: {
      number: t,
      text: e,
      html: s
    }
  };
}
function k(t) {
  return {
    message: "clearExamBrowserHistory",
    startTime: t
  };
}
const p = {
  message: "examSubmit"
}, w = {
  message: "examLoaded"
}, b = {
  message: "examClosed"
};
class x {
  constructor() {
    n(this, "callbacks");
    n(this, "protectedCallbacks");
    this.callbacks = /* @__PURE__ */ new Map(), this.protectedCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * Reset/empty this callback collection.
   */
  reset() {
    this.callbacks = /* @__PURE__ */ new Map(), this.protectedCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * Add a new callback for this event.
   * @param eventName Event name
   * @param callback The callback
   * @param clearExisting Whether or not to clear/remove existing non-protected callbacks for this event prior to adding this callback.
   * @param isProtected Whether or not this callback is protected against being removed/cleared.
   */
  put(e, s, o = !1, i = !1) {
    if (o && this.clear(e), this.callbacks.has(e) || (this.callbacks.set(e, []), this.protectedCallbacks.set(e, [])), i) {
      const l = this.protectedCallbacks.get(e);
      l == null || l.push(s.toString()), this.protectedCallbacks.set(
        e,
        l
      );
    }
    const a = this.callbacks.get(e);
    a == null || a.push(s), this.callbacks.set(e, a);
  }
  /**
   * Get the callbacks for this event.
   * @param eventName Event name
   * @returns Array of functions
   */
  get(e) {
    return this.callbacks.get(e);
  }
  /**
   * Checks if this collection has atleast 1 callback for the provided eventName.
   * @param eventName Event name
   * @returns boolean
   */
  has(e) {
    const s = this.callbacks.get(e);
    return s !== void 0 && s.length > 0;
  }
  /**
   * Clear all non-protected callbacks for this event.
   * @param eventName Event name
   */
  clear(e) {
    const s = this.protectedCallbacks.get(e);
    if (s === void 0 || (s == null ? void 0 : s.length) === 0) {
      this.callbacks.set(e, []);
      return;
    }
    const o = this.callbacks.get(e);
    o == null || o.forEach((i, a) => {
      s != null && s.includes(i.toString()) || o.splice(a, 1);
    }), this.callbacks.set(e, o);
  }
  /**
   * Run all callbacks for this event.
   * @param event The event
   */
  run(e) {
    const s = this.callbacks.get(
      e.data.message
    );
    s == null || s.forEach((o) => o(e.data));
  }
  /**
   * Run all callbacks for this eventName.
   * @param eventName The events name
   * @param data Optional data
   */
  runForEventName(e, s) {
    const o = this.callbacks.get(e);
    o == null || o.forEach((i) => i(s));
  }
}
class f {
  constructor() {
    n(this, "allowedCallbackEvents", [
      "honorlock:instructions:launchProctoring",
      "honorlock:extension:installedSuccessfully",
      "honorlock:extension:sessionSetupSuccess",
      "honorlock:extension:sessionSetupError",
      "honorlock:extension:beginExam",
      "honorlock:instructions:resized",
      "honorlock:extension:contentScriptInjected",
      "honorlock:extension:removed",
      "honorlock:extension:offline",
      "honorlock:extension:installed",
      "honorlock:exam:loaded"
    ]);
    n(this, "callbackCollection");
    n(this, "sessionConfig");
    n(this, "sessionSetupError", !1);
    n(this, "listeningForMessages", !1);
    n(this, "initialized");
    n(this, "handleMessageListeners", (e) => {
      this.allowedCallbackEvents.includes(e.data.message) && this.runCallbacks(e);
    });
    this.callbackCollection = new x(), this.initialized = !1, this.setupDefaultCallbacks();
  }
  get isInitialized() {
    return this.initialized;
  }
  get isListeningForMessages() {
    return this.listeningForMessages;
  }
  async init() {
    if (this.isInitialized)
      return;
    this.setupListeners(), window.postMessage(
      u(this.pageHasExtensionInstallIframe()),
      window.origin
    );
    const e = /* @__PURE__ */ new Date();
    return new Promise((s, o) => {
      const i = () => {
        if ((/* @__PURE__ */ new Date()).getTime() - e.getTime() > 1e4)
          return o("platformInit timed out");
        if (this.initialized)
          return s();
        setTimeout(i, 100);
      };
      i();
    });
  }
  async setupSession(e) {
    if (this.sessionConfig)
      throw "Session has already been setup!";
    window.postMessage(d(e), window.origin), this.callbackCollection.put(
      "honorlock:extension:sessionSetupSuccess",
      () => {
        this.sessionConfig = e, this.callbackCollection.put(
          "honorlock:instructions:launchProctoring",
          () => {
            window.postMessage(
              m(
                e.session.session.uuid,
                e.session.camera_url
              ),
              window.origin
            );
          },
          !0
        );
      },
      !0
    ), this.callbackCollection.put(
      "honorlock:extension:sessionSetupError",
      () => {
        this.sessionSetupError = !0;
      },
      !0
    );
    const s = /* @__PURE__ */ new Date();
    return new Promise((o, i) => {
      const a = () => {
        if ((/* @__PURE__ */ new Date()).getTime() - s.getTime() > 1e4 || this.sessionSetupError)
          return i("Session setup failed!");
        if (this.sessionConfig)
          return o();
        setTimeout(a, 100);
      };
      a();
    });
  }
  onLaunchProctoringIframeResize(e) {
    this.callbackCollection.put("honorlock:instructions:resized", e);
  }
  onExtensionVerified(e) {
    this.callbackCollection.put(
      "honorlock:extension:installedSuccessfully",
      e
    );
  }
  onBeginExam(e) {
    this.callbackCollection.put("honorlock:extension:beginExam", e);
  }
  onExtensionRemoved(e) {
    this.callbackCollection.put("honorlock:extension:removed", e);
  }
  onExtensionOffline(e) {
    this.callbackCollection.put("honorlock:extension:offline", e);
  }
  /**
   * Register a callback that is executed when an exam is submitted.
   * Only 1 onExamSubmit callback is supported.
   *
   * If an onExamSubmit callback has already been registered, subsequent calls to this method will throw an exception.
   *
   * @throws Exception
   */
  onExamSubmit(e) {
    if (this.callbackCollection.has("honorlock:exam:submit"))
      throw "An onExamSubmit callback has already been registered. Only 1 onExamSubmit callback is supported.";
    this.callbackCollection.put("honorlock:exam:submit", e, !1, !0);
  }
  /**
   * Informs the student chrome extension that the exam has been closed.
   */
  examClosed() {
    window.postMessage(b, window.origin), this.reset();
  }
  /**
   * Attempt to submit the exam.
   *
   * If no onExamSubmit callback has been registered, an exception will be thrown and the exam will NOT be submitted.
   *
   * @throws Exception
   */
  examSubmit() {
    if (!this.callbackCollection.has("honorlock:exam:submit"))
      throw "No exam submit callback!";
    window.postMessage(p, window.origin), this.callbackCollection.runForEventName("honorlock:exam:submit"), this.reset();
  }
  pageHasExtensionInstallIframe() {
    const e = Array.from(document.getElementsByTagName("iframe")), s = new RegExp(
      /^(?:[^.]+\.)*honorlock\.com(\/.*)?\/install\/extension(\?.*)?$/
    );
    return !e.every((i) => !s.test(i.src));
  }
  questionLoaded(e, s, o) {
    window.postMessage(
      g(
        e,
        s,
        o
      ),
      window.origin
    );
  }
  onExamLoaded(e) {
    this.callbackCollection.put("honorlock:exam:loaded", e, !1, !0);
  }
  examLoaded(e = null) {
    window.postMessage(w, window.origin), e !== null && window.postMessage(
      k(e),
      window.origin
    );
  }
  setupListeners() {
    this.listeningForMessages || (window.addEventListener("message", this.handleMessageListeners), this.listeningForMessages = !0);
  }
  reset() {
    window.removeEventListener("message", this.handleMessageListeners), this.listeningForMessages = !1, this.callbackCollection.reset(), this.sessionConfig = void 0, this.sessionSetupError = !1, this.initialized = !1, this.setupDefaultCallbacks();
  }
  runCallbacks(e) {
    this.callbackCollection.run(e);
  }
  setupDefaultCallbacks() {
    this.callbackCollection.put(
      "honorlock:extension:contentScriptInjected",
      () => {
        this.initialized = !0;
      }
    ), this.callbackCollection.put("honorlock:extension:installed", () => {
      window.location.reload();
    });
  }
}
globalThis.Honorlock = new f();
export {
  f as Honorlock
};
